// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import LabeledText from './LabeledText';
// import StatusChip from './StatusChip';

// export default function RideBookingCard({ ride }) {
//   const navigate = useNavigate();
//   const [isPaymentWindowOpen, setIsPaymentWindowOpen] = useState(false);

//   useEffect(() => {
//     const createdTime = new Date(ride.createdAt).getTime();
//     const age = Date.now() - createdTime;
//     const timeLeft = 15 * 60 * 1000 - age;

//     const paymentStatus = ride.paymentDetails?.status?.toLowerCase() || null;

//     if (
//       ride.isRideConfirmed === 0 &&
//       (!paymentStatus || paymentStatus === 'created') &&
//       timeLeft > 0
//     ) {
//       setIsPaymentWindowOpen(true);

//       const timeout = setTimeout(() => {
//         setIsPaymentWindowOpen(false);
//       }, timeLeft);

//       return () => clearTimeout(timeout); // Clean up on unmount
//     }
//   }, [ride]);

//   const getStatusLabel = (code) => ({
//     0: '⏳ Pending',
//     1: '✅ Confirmed',
//     2: '❌ Cancelled',
//   }[code]);

//   const getPaymentLabel = (status) => {
//     switch ((status || '').toLowerCase()) {
//       case 'success':
//         return '💰 Paid';
//       case 'failure':
//         return '❌ Failed';
//       case 'created':
//       default:
//         return '🚫 Not Paid';
//     }
//   };

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-md border">
//       {/* Header */}
//       <div className="flex justify-between mb-2">
//         <h2 className="text-lg font-semibold">
//           {new Date(ride.fromDate).toLocaleDateString()} → {new Date(ride.toDate).toLocaleDateString()}
//         </h2>
//         <span className="text-sm text-gray-500">{ride.name}</span>
//       </div>

//       {/* Timing */}
//       <div className="mb-3">
//         <h3 className="text-sm font-medium text-blue-600">Timing</h3>
//         <LabeledText label="Pickup Time" value={ride.pickupTime} />
//         <LabeledText label="Login" value={ride.officeArrivalTime} />
//         <LabeledText label="Logout" value={ride.officeDepartureTime} />
//       </div>

//       {/* Addresses */}
//       <div className="mb-3">
//         <h3 className="text-sm font-medium text-blue-600">Addresses</h3>
//         <LabeledText label="Home" value={ride.homeAddress} />
//         <LabeledText label="Office" value={ride.officeAddress} />
//       </div>

//       {/* Summary */}
//       <div className="mb-3">
//         <h3 className="text-sm font-medium text-blue-600">Summary</h3>
//         <LabeledText label="Fare" value={`₹${ride.fare.toFixed(2)}`} />
//         <LabeledText label="Distance" value={`${ride.distance} km`} />
//         <LabeledText label="Passengers" value={ride.passengerCount} />
//       </div>

//       {/* Chips */}
//       <div className="flex gap-2 flex-wrap mb-4">
//         <StatusChip label={getStatusLabel(ride.isRideConfirmed)} color="yellow" />
//         <StatusChip label={getPaymentLabel(ride.paymentDetails?.status)} color="green" />
//       </div>

//       {/* Payment Info */}
//       {ride.paymentDetails?.status?.toLowerCase() === 'success' && (
//         <div className="text-sm text-gray-600 mb-3">
//           <p><strong>Order ID:</strong> {ride.paymentDetails.orderId}</p>
//           <p><strong>Payment ID:</strong> {ride.paymentDetails.paymentId}</p>
//         </div>
//       )}

//       {/* Actions */}
//       <div className="flex flex-col gap-2">
//         {isPaymentWindowOpen && (
//           <>
//             <button
//               onClick={() => navigate(`/payment?rideBookingId=${ride.bookingId}`)}
//               className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//             >
//               💳 Pay Now
//             </button>
//             <p className="text-xs text-yellow-800 bg-yellow-100 rounded p-2">
//               Complete payment within 15 minutes.
//             </p>
//           </>
//         )}

//         {ride.isRideConfirmed === 1 && ride.driverMobileNumber && (
//           <a
//             href={`tel:${ride.driverMobileNumber}`}
//             className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 text-center"
//           >
//             📞 Call Driver
//           </a>
//         )}

//         {ride.isRideConfirmed === 1 && !ride.driverMobileNumber && (
//           <p className="text-sm text-gray-500">
//             Driver details will be available 1 hour before the ride starts.
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LabeledText from './LabeledText';
import StatusChip from './StatusChip';
import AssignmentInfoCard from './AssignmentInfoCard';
import { getAssignmentForBooking } from '../services/api';

export default function RideBookingCard({ ride }) {
  const navigate = useNavigate();
  const [isPaymentWindowOpen, setIsPaymentWindowOpen] = useState(false);
  const [assignment, setAssignment] = useState(null);

  // Payment window check
  useEffect(() => {
    if (!ride) return;

    const createdTime = new Date(ride.createdAt).getTime();
    const age = Date.now() - createdTime;
    const timeLeft = 15 * 60 * 1000 - age;

    const paymentStatus = ride.paymentDetails?.status?.toLowerCase() || null;

    if (
      ride.isRideConfirmed === 0 &&
      (!paymentStatus || paymentStatus === 'created') &&
      timeLeft > 0
    ) {
      setIsPaymentWindowOpen(true);

      const timeout = setTimeout(() => {
        setIsPaymentWindowOpen(false);
      }, timeLeft);

      return () => clearTimeout(timeout);
    }
  }, [ride]);

  // Fetch vendor assignment for confirmed rides
  useEffect(() => {
    if (ride?.isRideConfirmed === 1) {
      getAssignmentForBooking(ride.bookingId)
        .then((res) => {
          if (res.data.data) {
            setAssignment(res.data.data);
          }
        })
        .catch(() => {
          // Silently ignore — no assignment yet
        });
    }
  }, [ride?.bookingId, ride?.isRideConfirmed]);

  // ✅ Safety guard — render nothing if ride is invalid
  if (!ride || !ride.bookingId) {
    return null;
  }

  const getStatusLabel = (code) =>
    ({
      0: '⏳ Pending',
      1: '✅ Confirmed',
      2: '❌ Cancelled',
      3: '🏁 Completed',
    }[code] || '❓ Unknown');

  const getPaymentLabel = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'success':
        return '💰 Paid';
      case 'failure':
        return '❌ Failed';
      case 'created':
      default:
        return '🚫 Not Paid';
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md border">
      {/* Header */}
      <div className="flex justify-between mb-2">
        <h2 className="text-lg font-semibold">
          {new Date(ride.fromDate).toLocaleDateString()}{' '}
          {ride.toDate && `→ ${new Date(ride.toDate).toLocaleDateString()}`}
        </h2>
        <span className="text-sm text-gray-500">Booking #{ride.bookingId}</span>
      </div>

      {/* Timing */}
      <div className="mb-3">
        <h3 className="text-sm font-medium text-blue-600">Timing</h3>
        <LabeledText label="Pickup Time" value={ride.pickupTime} />
        <LabeledText label="Login" value={ride.officeArrivalTime} />
        <LabeledText label="Logout" value={ride.officeDepartureTime} />
      </div>

      {/* Addresses */}
      <div className="mb-3">
        <h3 className="text-sm font-medium text-blue-600">Addresses</h3>
        <LabeledText label="Home" value={ride.homeAddress} />
        <LabeledText label="Office" value={ride.officeAddress} />
      </div>

      {/* Summary */}
      <div className="mb-3">
        <h3 className="text-sm font-medium text-blue-600">Summary</h3>
        <LabeledText
          label="Fare"
          value={ride.fare != null ? `₹${ride.fare.toFixed(2)}` : '—'}
        />
        <LabeledText label="Distance" value={`${ride.distance} km`} />
        <LabeledText label="Passengers" value={ride.passengerCount} />
      </div>

      {/* Status chips */}
      <div className="flex gap-2 flex-wrap mb-4">
        <StatusChip label={getStatusLabel(ride.isRideConfirmed)} color="yellow" />
        <StatusChip
          label={getPaymentLabel(ride.paymentDetails?.status)}
          color="green"
        />
      </div>

      {/* Payment info */}
      {ride.paymentDetails?.status?.toLowerCase() === 'success' && (
        <div className="text-sm text-gray-600 mb-3 bg-gray-50 p-2 rounded">
          <p>
            <strong>Order ID:</strong> {ride.paymentDetails.orderId}
          </p>
          <p>
            <strong>Payment ID:</strong> {ride.paymentDetails.paymentId}
          </p>
        </div>
      )}

      {/* Vendor / Driver Assignment Info */}
      {ride.isRideConfirmed === 1 && (
        <AssignmentInfoCard assignment={assignment} />
      )}

      {/* Actions */}
      <div className="flex flex-col gap-2 mt-4">
        {/* Pay Now button — only for unpaid pending bookings within 15 min */}
        {isPaymentWindowOpen && (
          <>
            <button
              onClick={() =>
                navigate(`/payment?rideBookingId=${ride.bookingId}`)
              }
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              💳 Pay Now
            </button>
            <p className="text-xs text-yellow-800 bg-yellow-100 rounded p-2">
              ⏰ Complete payment within 15 minutes to confirm your booking.
            </p>
          </>
        )}
      </div>
    </div>
  );
}